import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardDetectorComponent } from './card-detector/card-detector.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { LoadingSpinnerComponentComponent } from './loading-spinner-component/loading-spinner-component.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { WhatsappButtonComponent } from './whatsapp-button/whatsapp-button.component';

@NgModule({
  declarations: [
    CardDetectorComponent,
    LoadingSpinnerComponentComponent,
    HeaderComponent,
    FooterComponent,
    WhatsappButtonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    FontAwesomeModule,
    NgxMaskDirective,
    NgxMaskPipe,
    RouterModule
  ],
  exports: [
    CardDetectorComponent,
    LoadingSpinnerComponentComponent,
    CommonModule,
    MaterialModule,
    FontAwesomeModule,
    HeaderComponent,
    FooterComponent,
    WhatsappButtonComponent
  ],
})
export class SharedModule { }
